/*
 * Copyright (c) 2022. American Express Company
 */

import $ from 'jquery';
import { Component, ReactNode } from 'react';

export default class BasicDrawer<P, S> extends Component<P, S> {
    private initialLoad: boolean = false;

    constructor(props: any) {
        super(props);
        this.initialLoad = true;
    }

    public override componentDidMount(): void {
        if (this.initialLoad) {
            this.initialLoad = false;
            // TODO: remove when we phase out mui
            $('.bw-drawer > .MuiPaper-root').scrollTop(0);
            $('.bw-drawer > .genericDrawer').scrollTop(0);
        }
    }

    public override render(): ReactNode {
        return this.props.children;
    }
}
